import Router from "./Routes";
import { useEffect } from "react";
import { SocketProvider } from "./context/SocketContext";
import {
  requestNotificationPermission,
  foregroundNotification,
} from "./service/firebaseNotification";

const App = () => {
  useEffect(() => {
    requestNotificationPermission();

    foregroundNotification();
  }, []);

  return (
    <>
      <SocketProvider>
        <Router />
      </SocketProvider>
    </>
  );
};

export default App;
